<template>
  <v-list three-line subheader>
    <v-subheader>{{ $t('ecr_list') }}</v-subheader>
    <v-list-tile dense v-for="(item, i) in local" :key="item.device_id">
      <v-list-tile-action>
        <span>{{ i + 1 }}.</span>
      </v-list-tile-action>
      <v-list-tile-content>
        <v-list-tile-title
          v-html="row(item.desc, item.device.sn, price)"
        ></v-list-tile-title>
        <v-list-tile-sub-title v-html="item.subtitle"></v-list-tile-sub-title>
      </v-list-tile-content>

      <v-list-tile-action>
        <v-icon :color="'red'" @click="updatelist(i)" small
          >remove_shopping_cart</v-icon
        >
      </v-list-tile-action>
    </v-list-tile>
    <v-divider></v-divider>
  </v-list>
</template>

<script>
export default {
  name: 'summary',
  props: {
    items: {
      type: Array,
      required: true
    },
    price: {
      type: Array
    }
  },
  data() {
    return {}
  },
  computed: {
    local() {
      return this.items ? this.items : []
    }
  },
  methods: {
    updatelist(i) {
      const d = Object.assign([], this.local.splice(i, 1))
      this.$emit('input', d)
      this.$emit('count')
    },
    row(name, sn, price) {
      return `<span class="justify-start">${name}</span>
              
              <span class="justify-end">${price[1]}Kč</span>
              <span class="ml-1">${this.$t('wo_vat')}</span>`
    }
  }
}
</script>
